import { Widget, WidgetSettingType } from '../base/widget/WidgetInterface'
import { WidgetHeightType, WidgetType } from '../base/widget/WidgetTypes'

export const columnsName: object = {
  'vehicleFmsStatusId': { name: 'FMS-Status ID' },
  'vehicleName': { name: 'Fahzeug-Name' },
  'vehicleFmsStatusTs': { name: 'FMS-Status Zeitstempel' },
  'vehicleFmsStatusNote': { name: 'FMS-Status Rückmeldung' }
}

export const WidgetVehicleStatus: Widget = {
  type: WidgetType.vehicleStatus,
  isFrameless: true,
  noPadding: true,
  title: 'Fahrzeug-Status',
  minSize: 4,
  defaultSize: 14,
  icon: 'Apps',
  defaultHeightType: WidgetHeightType.automatic,
  customSettings: {
    settings: {
      showFullTime: { type: WidgetSettingType.checkbox, title: 'Vollständige Uhrzeit anzeigen', checked: false },

      layoutHorizontal: { type: WidgetSettingType.checkbox, title: 'Horizontales Layout', checked: false },
      layoutHorizontalElementWidth: { type: WidgetSettingType.number, title: 'Elementbreite in %', value: 33, min: 10, max: 100 },
      lastColumnRightAligned: { type: WidgetSettingType.checkbox, title: 'Letze Spalte rechts ausrichten', checked: false },

      sortColumns: { type: WidgetSettingType.custom, data: {}, template: 'custom/SettingsPanelCustomVehicleStatusColumnSorting' },

      sortVehicles: { type: WidgetSettingType.custom, data: {}, template: 'custom/SettingsPanelCustomVehicleStatusVehicleSorting' },
      highlightAlarmedVehicles: { type: WidgetSettingType.checkbox, title: 'Alamierte Fahrzeuge hervorheben', checked: true },
      showOnlyAlarmedVehicles: { type: WidgetSettingType.checkbox, title: 'Nur alarmierte Fahrzeuge anzeigen', checked: false },
      showAlarmedVehiclesFirst: { type: WidgetSettingType.checkbox, title: 'Alarmierte Fahrzeuge zuerst anzeigen', checked: false },

      fontSize: { type: WidgetSettingType.number, title: 'Schriftgröße', value: 28, min: 14, max: 128 },
      fontSizeNoteAndTs: { type: WidgetSettingType.number, title: 'Schriftgröße, Rückmeldung & Zeit', value: 20, min: 14, max: 128 }
    },
    sections: [
      {
        label: 'Schriften',
        settings: [
          'fontSize',
          'fontSizeNoteAndTs'
        ]
      },
      {
        label: 'Fahrzeuge',
        settings: [
          'highlightAlarmedVehicles',
          'showOnlyAlarmedVehicles',
          'showAlarmedVehiclesFirst',
          'sortVehicles'
        ]
      },
      {
        label: 'Spalten',
        settings: [
          'sortColumns'
        ]
      }
    ]
  }
}

export default WidgetVehicleStatus
